import React, { Fragment, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FaPlus } from "react-icons/fa"
import { isNumeric } from "validator"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { clearDeliveryAddress } from "@redux"
import { Select, Tooltip } from "components"
import { getOnlyUserList } from "services"
import CheckoutAddUserModal from "./CheckoutAddUserModal"
import { formatMobilePhone } from "utils"
import classes from "./index.module.scss"

const CheckoutSelectUser = (props) => {
  const {
    isGuestOrder,
    isOrderEditable,
    selectedUserAccount,
    setSelectedUserAccount
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const orderForEditDetails =
    useSelector(state => state.orderForEditDetails)

  const isOnline =
    useSelector(state => !state.internetStatus.forceOffline) &&
    !orderForEditDetails?.offlineOrderId

  const [showAddUserModal, setShowAddUserModal] = useState(false)

  const timeout = useRef(null)

  const resetAllStates = () => {
    dispatch(
      clearDeliveryAddress()
    )

    setSelectedUserAccount(null)
  }

  const handleDeleteSelectedUser = () => {
    resetAllStates()
  }

  const handleSelectUser = (select) => {
    resetAllStates()

    setSelectedUserAccount(select.data)
  }

  const getUsers = async (inputValue, callback) => {
    const queries = { limit: 5 }

    if (isNumeric(inputValue)) {
      queries.mobilePhone =
        inputValue[0] === "0"
          ? inputValue.substring(1)
          : inputValue
    } else {
      queries.fullName = inputValue
    }

    const { data: users } =
      await getOnlyUserList(queries)

    callback(
      users.map(user => ({
        label: `${user.fullName} (${formatMobilePhone(user.mobilePhone)})`,
        value: user._id,
        data: user
      }))
    )
  }

  const handleSearch = (inputValue, callback) => {
    clearTimeout(timeout.current)

    timeout.current =
      setTimeout(() => getUsers(inputValue, callback), 600)
  }

  const disabled =
    !isOnline ||
    isGuestOrder ||
    !isOrderEditable ||
    orderForEditDetails !== null

  const value =
    !!selectedUserAccount
      ?
      {
        label: `${selectedUserAccount.fullName} ${selectedUserAccount.mobilePhone ? `(${formatMobilePhone(selectedUserAccount.mobilePhone)})` : ""}`,
        value: selectedUserAccount._id,
        data: selectedUserAccount
      }
      :
      null

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["container"]}>
        <Select
          async
          isClearable={!isGuestOrder}
          className={classes["select"]}
          isDisabled={disabled}
          label={t("مشتری_را_انتخاب_کنید_یا_اضافه_کنید")}
          loadOptions={handleSearch}
          noOptionsMessage={() => null}
          value={value}
          onChange={(select) =>
            !!select ? handleSelectUser(select) : handleDeleteSelectedUser()
          }
        />

        {
          !disabled &&
          <Tooltip title={t("افزودن_مشتری")}>
            <button
              onClick={() => setShowAddUserModal(true)}
              className={clsx(
                classes["button"],
                isLtr && classes["button-ltr"]
              )}
            >
              <FaPlus color="white" size={15} />
            </button>
          </Tooltip>
        }
      </div>

      <CheckoutAddUserModal
        resetAllStates={resetAllStates}
        showAddUserModal={showAddUserModal}
        setShowAddUserModal={setShowAddUserModal}
        setSelectedUserAccount={setSelectedUserAccount}
      />
    </Fragment>
  )
}

export default CheckoutSelectUser